export default {
  data: function() {
    return {
      longTextFieldRules: [
        v =>
          (v && v.length <= 65535) ||
          "String value must be less than 65,535 characters"
      ],
      textFieldRules: [
        v =>
          (v && v.length >= 0 && v.length <= 255) ||
          "String value must be greater than zero and less than 255 characters"
      ],
      passwordRules: [
        v => v.length > 7 || "Password must be at least 8 characters long",
        v => /[0-9]/.test(v) || "Password must contain a number",
        v => /[a-zA-Z]/.test(v) || "Password must contain a number"
      ]
    }
  }
}
